
import React from "react";
import "./ProgressTrackertwo.css";
function ProgressTrackerreturn({ currentstep }) {




  const steps = [
    {
      title:'Return Requested', date:'9.10.2024'
    },
    {
      title:'Return Accepted', date:'9.10.2024'
    },
    {
      title:'Product Picked up', date:'9.10.2024'
    },
    {
      title:'Refund Process', date:'9.10.2024'
    },
  ]

  const getcurrentclass = (stepindex) => {
    if (stepindex === currentstep) {
      return "current";
    } else if (stepindex < currentstep) {
      return "completed";
    } else {
      return "";
    }
  };

  return (
    <div className="progress_tracker_two_section pt-40 pb-80">
     
        <div className="row">
          <div className="col-12 d-flex" style={{ justifyContent: "center" }}>
            <ol className="progress-tracker_two">
              {steps.map((item, index) => {
                return (
                  <li key={index} className={getcurrentclass(index + 1)}>
                    <div style={{display:'inline-block'}}>
                    <span className="order_title">{item.title}</span>
                    {item.titletwo ? <span className="order_title_2">{item.titletwo}</span> : null}
                   
                    <span className="date">{item.date}</span>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      
    </div>
  );
}

export default ProgressTrackerreturn;

